import React from "react";
import { BillableOverviewCard } from "./overview-card";
import { TotalBillableCard } from "./total-card";
import CalendarDatePicker from "ui/components/comp-507";
import { EvtHeader } from "components/header";
import {
  CONTRACTED_INFO,
  PENDING_INVOICE_INFO,
  BILLED_INFO,
  COLLECTED_INFO,
  CANCELLED_INFO,
  TOTAL_INFO,
} from "../constant";
import { BILLABLES_OVERVIEW } from "../constant";
import { Card } from "ui/components/card";

export function BillablesOverview({ dateRange, onDateRangeChange }) {
  return (
    <Card className="m-4 shadow-none">
      <EvtHeader title="Billables Overview" info={BILLABLES_OVERVIEW}>
        <CalendarDatePicker date={dateRange} setDate={onDateRangeChange} />
      </EvtHeader>

      <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 3xl:grid-cols-6 gap-4 px-6">
        <TotalBillableCard
          dateRange={dateRange}
          info={TOTAL_INFO}
        />
        <BillableOverviewCard
          status="contracted"
          label="Contracted"
          info={CONTRACTED_INFO}
          dateRange={dateRange}
        />
        <BillableOverviewCard
          status="pending_invoice"
          label="Pending Invoice"
          info={PENDING_INVOICE_INFO}
          dateRange={dateRange}
        />
        <BillableOverviewCard
          status="billed"
          label="Billed"
          info={BILLED_INFO}
          dateRange={dateRange}
        />
        <BillableOverviewCard
          status="collected"
          label="Collected"
          info={COLLECTED_INFO}
          dateRange={dateRange}
        />
        <BillableOverviewCard
          status="cancelled"
          label="Cancelled"
          info={CANCELLED_INFO}
          dateRange={dateRange}
        />
      </div>
    </Card>
  );
}
